import React from "react";
import RepresentativePerformanceResidence from "./RepresentativePerformanceResidence";
import RepresentativePerformanceNonResidence from "./RepresentativePerformanceNonResidence";
import { Seo } from "../../../components/Seo";
import { useTranslation } from "react-i18next";

const RepresentativePerformance = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo title={t("trackRecord.representative.seo.title")} description={t("trackRecord.representative.seo.des")} path="projects/residential" />
      <div className="representative_performance_wrap">
        <RepresentativePerformanceResidence />
        <RepresentativePerformanceNonResidence />
      </div>
    </>
  );
};

export default RepresentativePerformance;
